import * as React from "react";
const SvgFiRrBaseball = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-baseball_svg__a)">
      <path
        fill="#062147"
        d="M12 0a12 12 0 1 0 12 12A12.013 12.013 0 0 0 12 0m7.879 18.136a8 8 0 0 1-2.041-2.594l1.533-.613a1 1 0 1 0-.742-1.858l-1.445.578a7.5 7.5 0 0 1 0-3.3l1.445.578A1.002 1.002 0 0 0 20 9.985a1 1 0 0 0-.629-.916l-1.533-.613a8 8 0 0 1 2.041-2.594 9.936 9.936 0 0 1 0 12.272zM4.121 5.864a8 8 0 0 1 2.041 2.594l-1.533.613a1 1 0 1 0 .742 1.858l1.445-.578A8 8 0 0 1 7 12a8 8 0 0 1-.184 1.649l-1.445-.578A1.002 1.002 0 0 0 4 14.013a1 1 0 0 0 .629.916l1.533.613a8 8 0 0 1-2.041 2.594 9.936 9.936 0 0 1 0-12.272M5.507 19.59a9.96 9.96 0 0 0 2.511-3.306l1.611.645A1.002 1.002 0 0 0 11 15.987a1 1 0 0 0-.629-.916l-1.666-.666C8.9 13.618 8.999 12.811 9 12c-.001-.809-.1-1.615-.295-2.4l1.666-.666a1 1 0 1 0-.742-1.858l-1.611.645A9.96 9.96 0 0 0 5.507 4.41a9.95 9.95 0 0 1 12.986 0 10 10 0 0 0-2.511 3.306l-1.611-.645a1 1 0 0 0-.742 1.858L15.3 9.6a9.95 9.95 0 0 0 0 4.81l-1.666.666a1 1 0 1 0 .742 1.858l1.611-.645a10 10 0 0 0 2.511 3.306 9.95 9.95 0 0 1-12.986 0z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-baseball_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBaseball;
